import {
  EDIT_TEMPORARY_PRICE_REQUESTED,
  EDIT_TEMPORARY_PRICE_SUCCEEDED,
  GET_TEMPORARY_PRICE_REQUESTED,
  GET_TEMPORARY_PRICE_SUCCEEDED
} from './edit.actions';
import { Router } from '@angular/router';
import { put, takeEvery } from 'redux-saga/effects';
import { API_CALL_ERROR } from '../../../../store/action';
import { ApiService } from '../../../../api/api.service';
import { AppInjector } from '../../../../app-injector';
import store from "../../../../store/store.module";
import {FILTER_USERS_REQUESTED} from "../../../user/list/list.actions";
import {PRODUCT_EDIT_TEMPORARY_PRICE_COMP} from "../../product.const";

function* editTemporaryPrice(action) {
  const api = AppInjector.get(ApiService);
  const router = AppInjector.get(Router);
  try {
    let result = yield api.product.editTemporaryPrice(action.data).toPromise();
    yield put({ type: EDIT_TEMPORARY_PRICE_SUCCEEDED, data: result });
    router.navigate(['product/edit/' + action.data.product_id]);
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchEditTemporaryPrice() {
  yield takeEvery(EDIT_TEMPORARY_PRICE_REQUESTED, editTemporaryPrice);
}

function* getTemporaryPrice(action) {
  const api = AppInjector.get(ApiService);
  const router = AppInjector.get(Router);
  try {
    let result = yield api.product.getTemporaryPrice(action.data).toPromise();
    if (result.valid_for) {
      yield put({ type: FILTER_USERS_REQUESTED, com: PRODUCT_EDIT_TEMPORARY_PRICE_COMP, data: { pagination: { page: 1, per_page: 10}, sort: null, filter: { id: result.valid_for } }});
    }
    yield put({ type: GET_TEMPORARY_PRICE_SUCCEEDED, data: result });
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchGetTemporaryPrice() {
  yield takeEvery(GET_TEMPORARY_PRICE_REQUESTED, getTemporaryPrice);
}

export default [watchEditTemporaryPrice, watchGetTemporaryPrice];


